import type { RuntimeConfig } from 'nuxt/schema'
import { getDevEnvironmentOverrides, parseDevEnvironment } from '@utils/devEnvironment'

export const DEV_ENVIRONMENT_COOKIE_KEY = 'cue-subclient-dev-environment'

// Shared consumers may resolve nuxt/schema from a different app's type context.
type BookingConfig = RuntimeConfig & {
  BACKEND_URL?: string
  public: { APP_ENV: string; BACKEND_URL: string; S3_URL: string }
}

export function createBookingDevEnvironment(config: RuntimeConfig, value: unknown) {
  const settings = parseDevEnvironment(value)
  const overrides = getDevEnvironmentOverrides(settings)
  return {
    settings,
    defaults: {
      APP_ENV: config.public.APP_ENV,
      BACKEND_URL: config.public.BACKEND_URL,
      S3_URL: config.public.S3_URL,
    },
    config: {
      ...config,
      BACKEND_URL: overrides.BACKEND_URL ?? ('BACKEND_URL' in config ? config.BACKEND_URL : ''),
      public: { ...config.public, ...overrides },
    },
  }
}

export function getBookingConfig(): BookingConfig {
  const nuxtApp = tryUseNuxtApp()
  const environment = import.meta.dev ? getBookingDevEnvironment() : undefined
  return (environment?.config ?? nuxtApp?.$config ?? useRuntimeConfig()) as BookingConfig
}

// Both apps consume this contract through their own Nuxt plugin/type context.
export function getBookingDevEnvironment() {
  return tryUseNuxtApp()?.$devEnvironment as ReturnType<typeof createBookingDevEnvironment> | undefined
}
